import { actions } from 'react-redux-form'
import { replace } from 'react-router-redux'
import { setLanguage, addMessage, addFile, setShowIntercom, addError } from 'actions'
import { languages } from 'i18n'
import CandidateService from 'interview/services/candidate'
import moment from 'moment-timezone'
import { deleteVideoResponse, updateVideoResponse } from 'actions/video-response'

export const CANDIDATE_RECEIVE = 'CANDIDATE_RECEIVE'
export const CANDIDATE_UPDATE_STATE = 'candidate/update-state'
export const CANDIDATE_SAVE_RESPONSE = 'candidate/save-response'
export const CANDIDATE_UPDATE_STATE_SUCCESS = 'candidate/state-update-success'
export const CANDIDATE_SAVE_RESPONSE_SUCCESS = 'candidate/response-save-success'
export const CANDIDATE_ERROR = 'candidate/error'

export const receiveCandidate = payload => ({ type: CANDIDATE_RECEIVE, payload })

export const updateState = (
  uuid,
  questionId,
  noUpdate,
  hasNotAnsweredToRequired,
  testSuccess,
) => (dispatch, getState, { emit }) => {
  const payload = {
    uuid,
    questionId,
    noUpdate,
    hasNotAnsweredToRequired,
    testSuccess,
  }
  emit({ type: CANDIDATE_UPDATE_STATE, payload })
}

export const saveResponse = payload => (dispatch, getState, { emit }) => {
  emit({ type: CANDIDATE_SAVE_RESPONSE, payload })
}

export const postAttachment = (model, uuid, data) => (dispatch, getState) => {
  const { candidate } = getState()
  return CandidateService.postAttachment(uuid, data)
    .then(() => {
      const { key, name, datauri } = data
      dispatch(addFile(key, datauri))
      dispatch(actions.push(model, { key, name }))
    })
    .catch((err) => {
      if (err.response && err.response.status && err.response.status === 400) {
        const language = (candidate && candidate.opening && candidate.opening.language) || 'en'
        if (err.response.response.includes('type')) {
          dispatch(addMessage({ style: 'warning', text: languages[language].component.attachments.errors.typeNotWhitelisted }))
        } else if (err.response.response.includes('size')) {
          dispatch(addMessage({ style: 'warning', text: languages[language].component.attachments.errors.size }))
        } else {
          dispatch(addError(err))
        }
      }
    })
}

export const fetchCandidate = (params, context, pathName) => (dispatch, getState) => CandidateService.get(params.token, context)
  .then((response) => {
    // TODO: should we show intercom messenger here? We don't have the company data here
    // so it also shows our own support email in the footer even if there was custon support enabled (should probably be fixed too)

    // if interview has publishTime and it is in the future the response will contain the publishTime
    if (response.publishTime && moment(response.publishTime) > moment()) {
      // Change UI language based on openings language setting
      if (response.language in languages) {
        dispatch(setLanguage(response.language))
      } else {
        // Fallback to english
        dispatch(setLanguage('en'))
      }
      if (pathName && pathName.includes('unpublished')) {
        dispatch(actions.merge('candidate.opening', { publishTime: response.publishTime }))
      } else {
        const path = context === 'sequenced-interview' ? context : 'enter'
        dispatch(replace(`/${path}/${params.token}/unpublished`))
      }
    } else {
      const candidate = response
      const company = candidate.opening && candidate.opening.company
      // Webcam use parameter has to detect if video exists
      candidate.videoResponses.map((response) => {
        response.has = !!response.videoUrl
      })
      dispatch(receiveCandidate(candidate))
      dispatch(actions.change('candidate', candidate))
      dispatch(setShowIntercom(company))
      // Change UI language based on openings language setting
      if (candidate.opening.language in languages) {
        dispatch(setLanguage(candidate.opening.language))
      } else {
        // Fallback to english
        dispatch(setLanguage('en'))
      }
      // If interview has endpoint the allowWithdraw in the response will be false
      const { routing } = getState()
      const location =
        routing &&
        routing.locationBeforeTransitions &&
        routing.locationBeforeTransitions.pathname
      if (
        location &&
        location.includes('withdraw') &&
        response.allowWithdraw === false
      ) {
        const path = context === 'sequenced-interview' ? context : 'enter'
        dispatch(replace(`/${path}/${params.token}`))
      }
    }
  })
  .catch((err) => {
    // TODO: should we show intercom messenger here? We don't have the company data here
    // so it also shows our own support email in the footer even if there was custon support enabled
    if (err.response && err.response.status === 404) {
      if (context === 'embedded') {
        dispatch(replace('/interview/embedded/closed'))
      } else if (context === 'sequenced-interview') {
        dispatch(replace('/sequenced-interview/closed'))
      } else {
        dispatch(replace('/closed'))
      }
    } else {
      throw err
    }
  })

export const saveDraft = payload => (dispatch) => {
  if (payload.isMobile) {
    return CandidateService.putMobileVideoResponse(
      payload.uuid,
      {
        ...payload.response,
      },
    )
      .then((videoResponse) => {
        dispatch(updateVideoResponse('candidate', videoResponse, videoResponse))
      })
  }
  return CandidateService.putVideoResponse(
    payload.uuid,
    {
      ...payload.response,
    },
  )
    .then((videoResponse) => {
      dispatch(updateVideoResponse('candidate', videoResponse, videoResponse))
    })
}

export const removeDraft = payload => dispatch => CandidateService.deleteVideoResponse(
  payload.uuid,
  {
    ...payload.response,
  },
)
  .then((videoResponse) => {
    dispatch(deleteVideoResponse('candidate', videoResponse, videoResponse))
  })

export const completeVideo = payload => dispatch => CandidateService.putVideoResponse(
  payload.uuid,
  {
    ...payload.response,
    saved: true,
  },
)
  .then((videoResponse) => {
    dispatch(updateVideoResponse('candidate', videoResponse, videoResponse))
  })

export const completeInterview = (payload, isEmbedded) => () => {
  const candidate = {
    ...payload,
    completed: true,
  }
  return CandidateService.update(candidate, isEmbedded)
}
